var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.521,
    height: 26.481,
    viewBox: "0 0 17.521 26.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Academic_",
    "data-name": "Academic ",
    transform: "translate(-183.256 -28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65006",
    "data-name": "Path 65006",
    d: "M262.142,163.513a2.849,2.849,0,0,1-2.049,0l-2.267-.982-1.6-.691a4.928,4.928,0,1,0,9.815.618,4.981,4.981,0,0,0-.043-.618l-1.594.69Z",
    transform: "translate(-69.101 -126.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65007",
    "data-name": "Path 65007",
    d: "M183.256,300.649v5.786h10.112l.228-.628a3.3,3.3,0,1,1,5.143,0l.229.628h1.809v-5.786a3.55,3.55,0,0,0-3.551-3.551H186.808a3.55,3.55,0,0,0-3.55,3.551Z",
    transform: "translate(0 -254.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65008",
    "data-name": "Path 65008",
    d: "M227.929,31.419c.412-.179.412-.471,0-.65l-6.087-2.636a2.168,2.168,0,0,0-1.5,0l-6.087,2.636c-.412.179-.412.47,0,.65l.461.2-.039.31a.375.375,0,0,0-.052.726l-.28,3.924a1.8,1.8,0,0,0,.073.581l.227.682c.026.078.06.117.094.117s.068-.039.094-.117l.228-.682a1.8,1.8,0,0,0,.073-.581l-.279-3.924a.375.375,0,0,0-.054-.726l-.035-.288,1.066.461.522.226v2.014l1.723.747,2.261.979a2.166,2.166,0,0,0,1.5,0l2.267-.982,1.724-.747V32.327l.521-.226Z",
    transform: "translate(-29.073 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65009",
    "data-name": "Path 65009",
    d: "M378.166,473.55a3.376,3.376,0,0,1-.393.077,3.241,3.241,0,0,1-.375.029h-.136a3.3,3.3,0,0,1-.375-.029,3.267,3.267,0,0,1-1.592-.674l-.817,2.245c-.035.1,0,.159.073.159a.209.209,0,0,0,.073-.015l.909-.338a.267.267,0,0,1,.092-.016.3.3,0,0,1,.254.142l.478.843c.031.055.068.083.1.083s.073-.033.1-.1l.4-1.112.367-1,.183.5.182.5.4,1.112c.024.067.061.1.1.1s.073-.028.1-.082l.479-.843a.3.3,0,0,1,.254-.142.266.266,0,0,1,.092.016l.909.338a.215.215,0,0,0,.073.015c.073,0,.107-.061.073-.159l-.817-2.245a3.293,3.293,0,0,1-1.2.6Z",
    transform: "translate(-181.163 -421.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65010",
    "data-name": "Path 65010",
    d: "M379.793,377.988a2.627,2.627,0,0,0,1.329.887,2.684,2.684,0,0,0,.394.08,2.608,2.608,0,0,0,2.11-.684,2.7,2.7,0,0,0,.261-.283,2.651,2.651,0,0,0,.237-.352,2.616,2.616,0,1,0-4.567,0,2.676,2.676,0,0,0,.237.352Zm.527-2.015a1.568,1.568,0,0,1,3.067.642,1.52,1.52,0,0,1-.062.251,1.554,1.554,0,0,1-.116.26,1.508,1.508,0,0,1-.117.177,1.565,1.565,0,0,1-2.5,0,1.548,1.548,0,0,1-.117-.177,1.582,1.582,0,0,1-.116-.26,1.61,1.61,0,0,1-.062-.252,1.58,1.58,0,0,1-.022-.254,1.541,1.541,0,0,1,.05-.387Z",
    transform: "translate(-185.671 -327.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65011",
    "data-name": "Path 65011",
    d: "M408.706,405l.216.21.056.055.008.008-.065.378-.063.367.668-.351.668.351-.063-.367-.065-.378.009-.008.056-.055.216-.21.241-.235.019-.018-.747-.109-.024-.049-.309-.628-.309.628-.024.049-.747.109.018.018Z",
    transform: "translate(-213.359 -356.204)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademic);
export default __webpack_public_path__ + "static/media/Academic.97eec48d071d24619497559a7041507e.svg";
export { ForwardRef as ReactComponent };